module.exports = __webpack_public_path__ + "static/media/panricoWhite@3x.8c238235.png";